<div class="store-finder flex-column pos-relative w-12">
    <div class="flex flex-justify-between center m-b-4 w-12">
        <h3 class="h3"
            translate>See in Store</h3>
        <button type="button"
                class="icon-chevron-left flex flex-middle bg-col-5 p-a-3"
                style="border-radius: 100%"
                aria-hidden="true"
                [style.font-size.rem]="0.8"
                (click)="close()"></button>

    </div>
    @if (store) {
    <store-details class="flex-grow"
                   [store]="store"></store-details>
    }
</div>